import React, { useRef, useEffect } from "react"
import ReactDOM from "react-dom"
import Button from "../Button"
import "./modal.scss"

export default function Modal(props) {
  const {
    close,
    isOpen,
    classes = [], //try not to use this anymore use className instead
    closeIcon,
    children,
    allowBackdropClose,
    className = " ",
  } = props

  let modalRef = useRef(null)

  useEffect(() => {
    modalRef.current = document.getElementById("portal-modal")
  }, [])

  useEffect(() => {
    const body = document.getElementsByTagName("body")

    if (isOpen) {
      body[0].setAttribute("style", "overflow:hidden")
    } else {
      body[0].removeAttribute("style")
    }
  }, [isOpen])

  if (!isOpen) {
    return null
  }

  let portalNode = modalRef.current

  const renderModal = () => {
    return (
      <div id="modal" className={`${isOpen ? "open" : "close"}`}>
        <div
          className={`modal-container ${
            classes && classes.join(" ")
          } ${className}`}
        >
          {closeIcon && (
            <i
              data-cy="modal-close-icon"
              className="glyphicon glyphicon-remove"
              onClick={close}
            />
          )}
          {children}
          {allowBackdropClose && <div className="backdrop" onClick={close} />}
        </div>
      </div>
    )
  }

  if (portalNode) {
    return !isOpen ? null : ReactDOM.createPortal(renderModal(), portalNode)
  }

  return renderModal()
}

export const ModalContent = (props) => {
  const { style, className = " " } = props
  return (
    <article className={`modal-content ${className}`} style={style}>
      {props.children}
    </article>
  )
}

export const ModalHeader = (props) => {
  return (
    <header className="modal-header" style={props.style}>
      <section style={{ flexGrow: 1 }}>
        <h2>{props.text}</h2>
      </section>
      {props.close && (
        <section>
          <i className="glyphicon glyphicon-remove" onClick={props.close} />
        </section>
      )}
    </header>
  )
}

export const ModalMessage = (props) => {
  const {
    messageType = "",
    className = "",
    text,
    style,
    closeModal,
    children,
  } = props
  return (
    <section
      className={`modal-message ${messageType} ${className}`}
      style={style}
    >
      {messageType == "success" && (
        <i className="success-icon fas fa-check" data-cy="modal-success-icon" />
      )}
      <p className="modal-message-text">{text}</p>
      {children}
      {closeModal && (
        <Button
          action={closeModal}
          classes={["btn-cancel"]}
          text={"Close"}
          data-cy="modal-close-button"
        />
      )}
    </section>
  )
}

export const ModalBtnGroup = (props) => {
  const { children, style, alignRight = false } = props
  let Buttons = React.Children.toArray(children)

  return (
    <div
      className="modal-buttons"
      style={{
        justifyContent: alignRight ? "flex-end " : "flex-start",
        ...style,
      }}
    >
      {React.Children.map(Buttons, (button, index) => {
        return React.cloneElement(button, {
          key: index,
          ...button.props,
          className: `${button.props.className} btn-modal`,
        })
      })}
    </div>
  )
}
